import React from 'react';
import { useTranslation } from 'react-i18next';
// port { Operation } from '../../../services/types/Operation';
import { customDateStr } from '../../shared/misc/utils';
import GeneralInfoItem from '../Operations/Operation/GeneralInfoItem';
import { GrievanceItem } from '../../services/types/Grievance';

interface Props {
  grievance: GrievanceItem;
}

const GIFinantialData: React.FC<Props> = ({ grievance }) => {
  const { t } = useTranslation();
  const dollarESLocale = Intl.NumberFormat('es');
  return (
    <div className="gi-items table-responsive">
      <GeneralInfoItem title={t('lendingType_type_modality')}>
        {grievance.lendingTypeModality}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('idbAmount')}>
        {grievance.idbAmount && `$ ${dollarESLocale.format(grievance.idbAmount)}`}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('totalProjectCost')}>
        {grievance.totalProjectCost && `$ ${dollarESLocale.format(grievance.totalProjectCost)}`}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('disbursementPercentage')}>
        {grievance.disbursedPercentage != null
          ? `${grievance.disbursedPercentage.toLocaleString('en-US', {
              maximumFractionDigits: 2,
            })} %`
          : ''}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('lastDisburstmentDate')}>
        {customDateStr(grievance.lastDisbDate)}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('reformulated')}>{grievance.isReformulated}</GeneralInfoItem>
      <GeneralInfoItem title={t('CoFinancing')}>{grievance.cofinancing}</GeneralInfoItem>
    </div>
  );
};

export default GIFinantialData;
